// Маппинг имени роута → ключ в pages_access
export const PAGE_ACCESS_KEYS = {
  CommunicationPosts: "communication_posts",
  CommunicationPostCreate: "communication_posts",
  CommunicationPostDetails: "communication_posts",
  CommunicationTags: "communication_posts",
  Analytics: "analytics",
  ActivityLog: "activity_logs",
  Orders: "orders",
  Sharings: "sharings",
  SharingCreate: "sharings",
  SharingEdit: "sharings",
  OrderDetails: "orders",
  OrderCreate: "orders",
  OrderCreateStep1: "orders",
  OrderCreateStep2: "orders",
  OrderCreateStep3: "orders",
  Trips: "trips",
  TripDetails: "trips",
  TripCreate: "trips",
  TripCargoDetails: "trips",
  Waybills: "waybills",
  WaybillDetails: "waybills",
  Chats: "chats",
  Counterparties: "counterparties",
  CounterpartyDetails: "counterparties",
  CounterpartyCreate: "counterparties",
  Drivers: "drivers",
  DriverDetails: "drivers",
  DriverCreate: "drivers",
  Repairs: "repairs",
  Warehouse: "warehouses",
  Fleet: "fleet",
  FleetCalendar: "fleet",
  Planning: "planning",
  Vehicles: "vehicles",
  VehicleDocuments: "vehicles",
  VehicleDetails: "vehicles",
  VehicleCreate: "vehicles",
  Expenses: "expenses",
  ExpenseCategories: "expenses",
  Users: "company_users",
  UserDetails: "company_users",
  UserInvite: "company_users",
  UserNew: "company_users",
  UserInviteSuccess: "company_users",
  UserInviteExpired: "company_users",
  Telemetry: "telemetry",
  Integrations: "integrations",
  IntegrationTrackers: "integrations",
  IntegrationSaby: "integrations",
  IntegrationChats: "integrations",
  IntegrationRnCard: "integrations",
  EdoDocuments: "edo_documents",
  EdoDocumentDetails: "edo_documents",
  EdoConsignmentNoteBuild: "edo_documents",
  EdoConsignmentNoteTitle2Edit: "edo_documents",
  EdoConsignmentNoteTitle3Edit: "edo_documents",
  EdoConsignmentNoteTitle4Edit: "edo_documents",
  EdoConsignmentNoteRedirectEdit: "edo_documents",
  EdoConsignmentNoteReplacementEdit: "edo_documents",
  EdoTransportOrderBuild: "edo_documents",
  EdoTransportOrderEdit: "edo_documents",
  EdoTransportOrderTitle2Edit: "edo_documents",
  EdoForwarderOrderBuild: "edo_documents",
  EdoForwarderOrderEdit: "edo_documents",
  EdoForwarderOrderTitle2Edit: "edo_documents",
  EdoForwarderReceiptBuild: "edo_documents",
  EdoForwarderReceiptEdit: "edo_documents",
  Settings: "settings",
  CompanyAttachments: "settings",
  TelemetrySettings: "settings",
  RequisiteTypes: "settings",
  Templates: "settings",
  VehicleInspectionSettings: "settings",
  TemplateDetails: "settings",
  ProductsRegistry: "settings",
  CatalogItems: "settings",
  CargoItems: "settings",
  CargoUnits: "settings",
  CargoProperties: "settings",
  ReferenceItems: "settings",
  PaymentSources: "settings",
  PermissionRoles: "settings",
};

// Дополнительные action permissions для страниц, которым недостаточно общего page access.
export const ROUTE_ACTION_PERMISSIONS = {
  VehicleInspectionSettings: {
    resource: "Fleet::Vehicle::InspectionStep",
    action: "update",
  },
};
